import UserProfileEditForm from './user-profile-edit-form-container';

export default UserProfileEditForm;
